/* eslint-disable no-unused-vars */
import { IPragmaticServerGame } from '../../types/interfaces/Slots/Pragmatic';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IConvertGameList } from '../../types/converter';
import { animatedIcons } from './animatedIcons';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter {
  convertGameList = ({ data, extraData }: IConvertGameList<IPragmaticServerGame[]>): ISlotViewItem[] => {
    const result: ISlotViewItem[] = data
      .filter(el => el.gameTypeID !== 'lg')
      .map((game: IPragmaticServerGame) => {
        return {
          id: game.gameID,
          imageUrl:
            animatedIcons[game.gameID] ||
            `https://${extraData.gameServerDomain || 'bsw-dk1.pragmaticplay.net'}/game_pic/square/200/${
              game.gameID
            }.png`,
          tab: getTab(game.gameID, game?.isNew),
          gameId: game.gameID,
          provider: 'pragmatic',
          isLiveGame: false,
          technologyId: game.technologyID,
          description: game.gameName,
          type: CasinoType.slots,
          gameName: game.gameName,
          routeProvider: 'pragmatic',
        };
      });

    return result;
  };

  // @ts-ignore
  convertGameUrl = ({ data }: IConvertGameUrl<IPragmaticGetUrlResponse>): string => data.url;

  convertData = (data: any) => ({
    ...data,
    gameServerDomain: data.game_server_domain,
    language: data.language,
  });
}

export default Converter;
